export default __webpack_public_path__ + "static/media/EMprint Bold.326840e4.ttf";